module.exports = __webpack_public_path__ + "static/media/icon-service-modulesA4.2750e547.png";